import React, {useState} from 'react'
import DatePicker, { registerLocale } from 'react-datepicker'
import { frCA, enUS, es, ptBR } from 'date-fns/locale'
import 'react-datepicker/dist/react-datepicker.css'
import dayjs from 'dayjs'
import dayjsPluginUTC from 'dayjs-plugin-utc'
import dayjsTimezone from 'dayjs/plugin/timezone'

// Tranlations
import t from '../../translations'

registerLocale('FR', frCA)
registerLocale('EN', enUS)
registerLocale('ES', es)
registerLocale('PT', ptBR)

dayjs.extend(dayjsPluginUTC)
dayjs.extend(dayjsTimezone)
const localTimezone = dayjs.tz.guess()

export default function TodoHistory(props) {

  const localDayjs = (dayjsDate) => {
    if(!dayjsDate){
      dayjsDate = dayjs()
    }
    return dayjsDate.utc('z').local().tz(localTimezone)
  }

  const now = localDayjs()
  const [startDate, setStartDate] = useState(props.isHistoryDate ? dayjs(props.isHistoryDate) : now)

  const calendarDates = (historyDates) => {

    historyDates = historyDates.map((date) => dayjs(date))

    const start = historyDates[0]
    const end = historyDates[historyDates.length - 1]

    const minDate = new Date(start)
    const maxDate = new Date(end)
    const highlightedDates = historyDates.map((date) => new Date(date))
    
    const excludeDates = []
    let loopingDate = dayjs(start)
    while (loopingDate.isBefore(dayjs(end))){
      loopingDate = loopingDate.add(1, 'day')

      // eslint-disable-next-line
      if(!historyDates.some((date) => date.isSame(loopingDate, 'day'))){
        excludeDates.push(new Date(loopingDate))
      }
    }

    return {highlightedDates, minDate, maxDate, excludeDates}
  }

  return (<>
    <h3>{t[props.lang]['Select a history date']}</h3>

    <div>
      <DatePicker
        inline
        showIcon
        selected={startDate.toString()}
        minDate={calendarDates(props.historyDates).minDate}
        maxDate={calendarDates(props.historyDates).maxDate}
        excludeDates={calendarDates(props.historyDates).excludeDates}
        dateFormat="yyyy-MM-dd"
        highlightDates={[
          {
            'todoHistoryExist': calendarDates(props.historyDates).highlightedDates,
          },
        ]}
        locale={props.lang}
        onChange={(date) => {
          setStartDate(dayjs(date.toString()))
          props.getHistoryData(dayjs(date.toString()).format('YYYY-MM-DD'))
        }}
      />
    </div>
  
    <div className='calendarButtonDiv'>
      {props.isHistoryDate && <button
        onClick={()=> {
          window.location.pathname = '/todo'
        }}
      >
        {t[props.lang][`Back to active list`]}
      </button>}
    </div>
    
  </>)
}